module.exports = __webpack_public_path__ + "static/cloudtalk-f45002ba18024eb4e69bddf09ad71fa7.png";